import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  snackbar,
  ConfirmDialog,
  Typography,
  TableRowActionsMenu,
  useConfirmDialog,
} from '@occc-app/design-system';
import { useOfferDeleteMutation } from '@occc-app/dataAccessLayer/offer/mutations';

import { routeCreator } from '../utils';

type LoyaltyEventActionsContainerProps = {
  id: string;
  name: string;
  isEditActionVisible: boolean;
  isArchiveActionVisible: boolean;
};

export const LoyaltyEventActionsContainer = ({
  id,
  name,
  isEditActionVisible,
  isArchiveActionVisible,
}: LoyaltyEventActionsContainerProps) => {
  const navigate = useNavigate();

  const onDeleteComplete = () => {
    snackbar.success('Loyalty Event has been successfully archived.');
  };

  const [offerDelete] = useOfferDeleteMutation({
    onCompleted: onDeleteComplete,
    refetchQueries: ['offers'],
  });

  const onDelete = () =>
    offerDelete({
      variables: { id },
    });

  const { open, setOpen, onCloseButtonClick, onConfirmButtonClick } = useConfirmDialog({
    onConfirm: onDelete,
    shouldStopEventPropagation: true,
  });

  const menuItems = useMemo(() => {
    const items = [];

    if (isEditActionVisible) {
      items.push({
        label: 'Edit Loyalty Event',
        onClick: () => navigate(routeCreator.updateWithTab(id)),
        dataTestId: 'edit',
      });
    }

    if (isArchiveActionVisible) {
      items.push({
        label: 'Archive Loyalty Event',
        onClick: () => setOpen(true),
        dataTestId: 'archive',
      });
    }

    return items;
  }, [id, navigate, setOpen, isEditActionVisible, isArchiveActionVisible]);

  return (
    <>
      <TableRowActionsMenu menuItems={menuItems} />
      <ConfirmDialog
        dialogTitle='Are you sure?'
        open={open}
        onClose={onCloseButtonClick}
        confirmButtonText='Confirm'
        confirmButtonProps={{
          onClick: onConfirmButtonClick,
          color: 'error',
        }}
      >
        <Typography>This action will archive the "{name}".</Typography>
      </ConfirmDialog>
    </>
  );
};
